import Base from "./base.js"

export default class User extends Base {
  constructor(object) {
    super("user")

    this.user = {
      userId: object.userId,
      status: {
        camera: object.status.camera,
        mic: object.status.mic
      }
    }
  }
}
